var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "1000px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isBatch,
              expression: "!isBatch"
            }
          ],
          staticStyle: {
            display: "flex",
            margin: "0 0 10px 10px",
            color: "#1F75D5"
          }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.contractNoPrice.pol) +
              " —————— " +
              _vm._s(_vm.contractNoPrice.pod) +
              " "
          )
        ]
      ),
      _c("div", { staticStyle: { display: "flex", "margin-bottom": "10px" } }, [
        _c("div", { staticStyle: { width: "80px", "margin-left": "10px" } }, [
          _vm._v(_vm._s(this.$t("CargoMsg.Cargo_CarrierShip")))
        ]),
        _c("span", { staticStyle: { color: "#1F75D5" } }, [
          _vm._v(
            _vm._s(
              _vm.ColumnUtils.resolveColumnLabel(
                _vm.TYPE_NAMES.basic_data_Company,
                "cmpIdx",
                _vm.contractNoPrice.carrierId,
                "chineseName"
              )
            )
          )
        ])
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-bottom": "10px" } }, [
        _c("div", { staticStyle: { width: "80px", "margin-left": "10px" } }, [
          _vm._v(_vm._s(this.$t("CargoMsg.Cargo_BookingAgent")))
        ]),
        _c("span", { staticStyle: { color: "#1F75D5" } }, [
          _vm._v(
            _vm._s(
              _vm.ColumnUtils.resolveColumnLabel(
                _vm.TYPE_NAMES.basic_data_Company,
                "cmpIdx",
                _vm.contractNoPrice.bookingAgent,
                "chineseName"
              )
            )
          )
        ])
      ]),
      _c(
        "div",
        { staticStyle: { display: "flex", "margin-bottom": "5px" } },
        [
          _c(
            "b",
            {
              staticStyle: {
                margin: "0 10px",
                "line-height": "28px",
                "font-size": "16px"
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("Message.Receivable")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.arAdd } },
            [_vm._v(_vm._s(_vm.$t("Partners.add")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.arDelete } },
            [_vm._v(_vm._s(_vm.$t("Partners.delete")))]
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", "min-height": "200px" },
        attrs: {
          "config-module": "100404",
          "grid-options": _vm.ar.gridOptions,
          "column-defs": _vm.ar.columnDefs,
          "row-data": _vm.ar.rowData
        },
        on: {
          gridReady: function(params) {
            _vm.ar.gridApi = params.api
          }
        }
      }),
      _c(
        "div",
        { staticStyle: { display: "flex", margin: "10px 0 5px 0" } },
        [
          _c(
            "b",
            {
              staticStyle: {
                margin: "0 10px",
                "line-height": "28px",
                "font-size": "16px"
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("Message.Payable")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.apAdd } },
            [_vm._v(_vm._s(_vm.$t("Partners.add")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.apDelete } },
            [_vm._v(_vm._s(_vm.$t("Partners.delete")))]
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", "min-height": "200px" },
        attrs: {
          "config-module": "100405",
          "grid-options": _vm.ap.gridOptions,
          "column-defs": _vm.ap.columnDefs,
          "row-data": _vm.ap.rowData
        },
        on: {
          gridReady: function(params) {
            _vm.ap.gridApi = params.api
          }
        }
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "b",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isBatch,
                  expression: "isBatch"
                }
              ],
              staticStyle: { float: "left" }
            },
            [_vm._v(_vm._s(_vm.$t("Partners.batchReplaceAfterSave")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }